import {combineReducers} from 'redux';
import * as common from './common';

export default combineReducers({
    ...common,
})